export function isBillingEnabled(): boolean {
  return import.meta.env.VITE_BILLING_ENABLED !== "false";
}

export function isSandboxHost(): boolean {
  if (typeof window === "undefined") {
    return import.meta.env.VITE_SANDBOX === "true";
  }
  return (
    import.meta.env.VITE_SANDBOX === "true" ||
    window.location.hostname.includes("-sandbox.")
  );
}
